import { useEffect, useRef } from "react";
import { NavLink, Outlet, useLocation } from "react-router";
import { OpenCharacterSwitcher, OpenCharacterTabs, useResendLeftPage } from "../components/OpenCharacters";
import { useOnScreenKeyboard } from "../onScreenKeyboard";
import { useCurrentUser } from "./AuthPages";

/** Publishes the height of the sticky head as --head-height, so other sticky parts and scroll targets stay clear of it. */
function useHeadHeight() {
  const head = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element = head.current;
    if (!element) return;
    const observer = new ResizeObserver(() => document.documentElement.style.setProperty("--head-height", `${element.offsetHeight}px`));
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return head;
}

export function AppShell() {
  const user = useCurrentUser();
  const head = useHeadHeight();
  const shell = useRef<HTMLDivElement>(null);
  useOnScreenKeyboard(shell);
  useResendLeftPage();
  const isCampaign = useLocation().pathname.startsWith("/k/");
  return (
    <div className="shell" ref={shell}>
      <div className="shell-head" ref={head}>
        <header className="topbar">
          <NavLink to="/" className="brand">
            Splitterträger
          </NavLink>
          <OpenCharacterSwitcher />
          <nav className="topnav" aria-label="Hauptnavigation">
            <NavLink to="/" end>
              Charaktere
            </NavLink>
            <NavLink to="/neu">Neu</NavLink>
            <NavLink to="/kampagnen" className={({ isActive }) => (isActive || isCampaign ? "active" : "")}>
              Kampagnen
            </NavLink>
            {user.role === "admin" && <NavLink to="/verwaltung">Verwaltung</NavLink>}
            <NavLink to="/profil">{user.displayName}</NavLink>
          </nav>
        </header>
        <OpenCharacterTabs />
      </div>
      <main className="content">
        <Outlet />
      </main>
      <nav className="bottomnav" aria-label="Navigation">
        <NavLink to="/" end>
          <span aria-hidden="true">☰</span>Charaktere
        </NavLink>
        <NavLink to="/neu">
          <span aria-hidden="true">＋</span>Neu
        </NavLink>
        <NavLink to="/kampagnen" className={({ isActive }) => (isActive || isCampaign ? "active" : "")}>
          <span aria-hidden="true">◈</span>Kampagnen
        </NavLink>
        {user.role === "admin" && (
          <NavLink to="/verwaltung">
            <span aria-hidden="true">⚙</span>Verwaltung
          </NavLink>
        )}
        <NavLink to="/profil">
          <span aria-hidden="true">●</span>Profil
        </NavLink>
      </nav>
    </div>
  );
}
